import Layout from '@modules/layout/components/layout';
import Permissions from '@security/permissions';

const SubpropertySettingsPage = () =>
  import('@modules/subproperty-settings/components/subproperty-settings-page.vue');

export default [
  {
    path: '',
    component: Layout,
    children: [
      {
        name: 'subpropertySettings',
        path: '/subproperty/settings',
        component: SubpropertySettingsPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
        },
      },
    ],
  },
];
